export const openExternalLink = ({newTab, url}) => {
  if(newTab) {
    window.open(
      url,
      "_blank",
      "noopener noreferrer"
    );
  } else {
    window.location = url;
  }
}
